import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Header from './Header';
import { Typography } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import './balloon.css';
import { Redirect, Link } from 'react-router-dom';

const styles = theme => ({
  root: {
    flexGrow: 1,
    padding: theme.spacing(1),
    paddingTop: theme.spacing(1),
    width: "100%",
  },
  textField: {
    width: "calc(80vmin)",
  },
  form: {
    marginLeft: "calc(3vmin)",
  },
  caption: {
    marginTop: theme.spacing(10),
    textAlign: "center",
    width: "100%",
  },
});

class Make extends React.Component {
  state = { label:"title", title:"", aid:null }

  async handleChange(value) {
    this.setState({title:value});
  }
  async handleEnter(e) {
    e.preventDefault();
    const { db, user } = this.props;
    const entry = { uid:user.uid };
    // Create a globally unique article ID
    const refArticles = db.collection("articles");
    const refDoc = await refArticles.add(entry);
    // Create an article for this user with that ID
    const refUser = db.collection("users").doc(user.uid);
    const refArticle = refUser.collection("articles").doc(refDoc.id);
    const article = { name:user.displayName, title:this.state.title, created:new Date() };
    await refArticle.set(article);

    this.setState({aid:refDoc.id});
  }

  render() {
    const { classes, user } = this.props;
    if (!user) {
      return (
        <React.Fragment>
          <Header user={user} login="/Login/target/make" />
          <Grid container justify="center" alignItems="center" direction="row" className={classes.root}>
            <Grid className={classes.caption}>
              <Typography component="h2" variant="h5" gutterBottom>
                Please log in. 
              </Typography>
            </Grid>
          </Grid>
        </React.Fragment>
      );
    }
    if (this.state.aid) {
      //const path = (window.location.hostname==="localhost") ? "/a/" : "/api/a/"; 
      const path = "/a/";
      return <Redirect to={path + this.state.aid} />
    }
    return (
      <React.Fragment>
        <Header user={user} />
        <div className={classes.root}>
              <form className={classes.form}>
                <TextField label="title" value={this.state.title} required autoFocus
                        className={classes.textField} margin="normal" 
                        onChange = {(e)=>this.handleChange(e.target.value)} />
              <Grid container spacing={1}>
                <Grid item>
                <Grid container spacing={1}>
                  <Grid item>
                    <Button disabled={this.state.title.length < 1} variant="outlined" color="primary" className={classes.button} type="submit"
                          onClick = {(e)=>this.handleEnter(e)}>
                     Create
                    </Button>
                  </Grid>
                  <Grid item>
                    <Button component={Link} variant="outlined" to="/">
                     Cancel
                    </Button>
                  </Grid>
                </Grid>
                  
                </Grid>
            </Grid>
            </form>
        </div>
      </React.Fragment>
    );
  }
}

Make.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Make);
